import { render } from "./Funds.vue?vue&type=template&id=a8ad1246&scoped=true"
import script from "./Funds.vue?vue&type=script&lang=js"
export * from "./Funds.vue?vue&type=script&lang=js"

import "./Funds.vue?vue&type=style&index=0&id=a8ad1246&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ad1246"]])

export default __exports__